import React, {useEffect, useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Space} from 'antd';
import {connect} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {StyledSettingPageContainer, StyledTabComponentContainer, StyledTabs} from '../SettingsPage/StyledSettingsPage';
import PageContainer from '../../components/PageContainer';
import PageDocumentDetails from '../../components/PageDocumentDetails';
import Notifications from '../../components/pages/ProfileSettingsPage/tabs/Notifications';
import PersonalInfo from '../../components/pages/ProfileSettingsPage/tabs/PersonalInfo';
import Companies from '../../components/pages/ProfileSettingsPage/tabs/Companies';
import BankingInfo from '../../components/pages/ProfileSettingsPage/tabs/BankingInfo';
import BalancePageHeader from '../../components/pages/TransactionsPage/BalancePageHeader';
import {locationHelpers} from '../../utils/helpers';
import {useIsEnabledUserOverview, useIsTreezorEnabled} from '../../hooks';
import routes from '../../routes/routes.json';

const ProfileSettingsPage = ({
  isEnabledBanking
}) => {
  const location = useLocation();
  const [t] = useTranslation(['profile', 'main']);
  const [tabs, setTabs] = useState([]);
  const [defaultActiveTab, setDefaultActiveTab] = useState(null);

  const isTreezorEnabled = useIsTreezorEnabled();

  const tabTrans = (key) => t(`tabs.${key}.title`);

  const isEnabledUserOverview = useIsEnabledUserOverview();

  const breadcrumbs = useMemo(() => {
    let list = [];
    if (isEnabledUserOverview) {
      list = [{title: t('main:home'), href: routes.overview}]
    }
    list = [...list, {title: t('title')}];
    return list;
  }, [t, isEnabledUserOverview]);

  useEffect(() => {
    const hash = locationHelpers.getLocationHash(location);
    if (hash && tabs.length > 0) {
      let searchedIndex = tabs.findIndex(t => t.key === hash && t.disabled !== true);
      if (searchedIndex >= 0) setDefaultActiveTab(searchedIndex);
    }
  }, [location.hash, tabs]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    let tabs = [
      {
        children: (
          <StyledTabComponentContainer
            align='start'
            size='large'
          >
            <Space
              direction='vertical'
              size='large'
            >
              <PersonalInfo />
              <Companies />
            </Space>
          </StyledTabComponentContainer>
        ),
        key: 'personal-info',
        label: tabTrans('personalInfo')
      },
      {
        children: (
          <StyledTabComponentContainer
            align='start'
            size='large'
          >
            <Notifications />
          </StyledTabComponentContainer>
        ),
        key: 'notifications',
        label: tabTrans('notifications')
      }
    ];
    if (isTreezorEnabled) {
      tabs = [
        ...tabs,
        {
          children: (
            <StyledTabComponentContainer
              align='start'
              size='large'
            >
              <BankingInfo />
            </StyledTabComponentContainer>
          ),
          disabled: !isEnabledBanking,
          key: 'banking-info',
          label: tabTrans('bankingInfo')
        }
      ]
    }
    setTabs(tabs);
  }, [isEnabledBanking, isTreezorEnabled]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <PageContainer>
      <PageDocumentDetails title={t('main:pageTitles.profile')} />
      <BalancePageHeader breadcrumbs={breadcrumbs} />
      <StyledSettingPageContainer>
        <StyledTabs
          defaultActiveKey={defaultActiveTab}
          type='card'
          items={tabs}
        />
      </StyledSettingPageContainer>
    </PageContainer>
  );
}

const mapStateToProps = ({ banking: { isEnabledBanking } }) => ({ isEnabledBanking });

export default connect(mapStateToProps, null)(ProfileSettingsPage);
